// extracted by mini-css-extract-plugin
export default {"betRecord":"styleModule_betRecord__ncCH5","loadingContainer":"styleModule_loadingContainer__EImIj"};